import axios from 'axios';
import notify from '@/store/Common/notify';

const settingsMixin = {
    data() {
        return {
            settingsLoading: true,
            settings: {}
        };
    },

    watch: {
        // watch the entire settings object (deeply)
        settings: {
            handler(newVal, oldVal) {
                console.log('MIXIN Settings Changed:', newVal, oldVal);
                this.doSomethingOnAnyChange();
            },
            deep: true      // 🔑 watch nested props
            //immediate: true  // optional: also run on component mount
        }

        // you can also watch a specific nested path
        // 'settings.nested.someKey'(newVal, oldVal) {
        //     console.log('nested.someKey changed from', oldVal, 'to', newVal)
        // }
    },

    mounted() {
        // noinspection JSUnresolvedVariable
        this.getSettingData(this.settingPage);
    },

    methods: {
        doSomethingOnAnyChange() {
            return false;
        },

        getSettingData(page) {
            this.settingsLoading = true;
            axios.get(`/api/settings/page/${page}`)
                .then(response => {
                    const settings = response.data.settings;

                    settings.forEach(settingGroup => {
                        for (let [name, setting] of Object.entries(settingGroup.settingArray)) {
                            this.settings[name] = setting;
                        }
                    });

                    this.settingsLoading = false;
                });
        },

        setPostData(name, settings) {
            return {
                settings: {
                    settingName: name,
                    settingArray: settings
                }
            };
        },

        saveSettings(page, settings) {
            axios.post(`/api/settings/page/${page}`, settings)
                .then((response) => {
                    notify(response.data.message, 'success');
                });
        }
    }
};

export default settingsMixin;
